/*
 * Reglas del bloque de archivos, las mismas que valida el backend
 * (StoreLessonFileRequest y FileBlock, LMS-070): extensiones permitidas, como
 * máximo `lms.file_max_kb` (50 MB) por fichero y de 1 a 20 ficheros por bloque.
 * Se comprueban antes de subir para no gastar la petición; el backend sigue
 * siendo quien decide (mira el contenido, no solo la extensión).
 */
export const FILE_EXTENSIONS = [
    'pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'odt', 'ods', 'odp', 'rtf', 'txt', 'csv',
    'zip', 'png', 'jpg', 'jpeg', 'gif', 'webp', 'mp3',
]
export const FILE_ACCEPT = FILE_EXTENSIONS.map((extension) => '.' + extension).join(',')
export const FILE_MAX_MB = 50
export const FILE_MAX_COUNT = 20

const extensionOf = (name) => {
    const dot = (name ?? '').lastIndexOf('.')
    return dot === -1 ? '' : name.slice(dot + 1).toLowerCase()
}

// Clave i18n del error o null si el fichero se puede subir.
export const fileUploadError = (file) => {
    if (!FILE_EXTENSIONS.includes(extensionOf(file.name))) return 'projects.file_type_invalid'
    return file.size > FILE_MAX_MB * 1024 * 1024 ? 'projects.file_too_large' : null
}

// Tamaño legible en el idioma de la interfaz: «820 KB», «12,5 MB».
export const formatFileSize = (bytes, locale) => {
    if (bytes === null || bytes === undefined) return ''
    const format = (value) => new Intl.NumberFormat(locale, {maximumFractionDigits: 1}).format(value)
    if (bytes < 1024 * 1024) return format(Math.max(1, Math.round(bytes / 1024))) + ' KB'
    return format(bytes / (1024 * 1024)) + ' MB'
}
